<template>
  <div class="list-editor-settings" :class="{ 'bg-pink': hidden }">
    <div style="margin-bottom: 10px; padding: 0 6px">
      <span class="subtitle">Settings</span>
      <label class="radio" style="margin-left: 16px; color: grey">
        <input type="checkbox" name="hidden" :value="true" v-model="hidden" />
        Hidden
      </label>
      <span class="link has-text-grey is-pulled-right" @click="close"
        >Close</span
      >
    </div>
    <div class="setting field has-addons" style="margin-bottom: 0">
      <p class="control">
        <a class="button is-readonly is-static">Label</a>
      </p>
      <p class="control is-expanded">
        <input
          class="input"
          type="text"
          placeholder="Hot Eats Morning"
          v-model="label"
        />
      </p>
    </div>
    <div class="setting">
      <!-- <span class="button is-light"> -->
      <label class="radio">
        <input
          type="checkbox"
          name="randomise"
          :value="true"
          v-model="randomise"
        />
        Randomise list order
      </label>
      <!-- </span> -->
    </div>
    <div class="setting">
      <label class="radio">
        <input
          type="checkbox"
          name="shopOpen"
          :value="true"
          v-model="shopOpen"
        />
        Show shops when open
      </label>
    </div>
    <div class="setting">
      <label class="radio">
        <input
          type="checkbox"
          name="timeSlot"
          :value="true"
          v-model="timeSlot"
        />
        Time slot
      </label>
      <div v-if="timeSlot">
        <div class="field has-addons" style="margin-bottom: 0">
          <p class="control">
            <a class="button is-static">Start</a>
          </p>
          <p class="control is-expanded">
            <input
              class="input"
              type="number"
              placeholder="0900"
              v-model="startTime"
            />
          </p>
          <p class="control">
            <a class="button is-static">End</a>
          </p>
          <p class="control is-expanded">
            <input
              class="input"
              type="number"
              placeholder="1200"
              v-model="endTime"
            />
          </p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "ListEditorSettings",
  props: {
    blob: Object, // list_title blob
  },
  data() {
    return {
      label: null,
      randomise: false,
      timeSlot: false,
      shopOpen: false,
      hidden: false,
      startTime: null,
      endTime: null,
    };
  },
  mounted() {
    console.log("listTitleBlob", this.blob);
    if (!this.blob) return; // will be null if List Title not yet created (not required)
    var o = this.blob.data.settings;
    if (!o) return;
    this.label = o.label;
    this.randomise = o.randomise;
    this.shopOpen = o.shop_open;
    this.hidden = o.hidden;
    if (o.time_slot) {
      this.timeSlot = true;
      this.startTime = o.time_slot.start;
      this.endTime = o.time_slot.end;
    }
  },
  methods: {
    validate() {
      if (parseInt(this.startTime) > parseInt(this.endTime)) {
        this.errorToast("Invalid times, please fix and save again");
      }
    },
    close() {
      this.save();
      this.$emit("close");
    },
    save() {
      this.validate();
      var settings = {
        label: this.label,
        randomise: this.randomise,
        shop_open: this.shopOpen,
        hidden: this.hidden,
      };
      if (this.timeSlot) {
        settings.time_slot = { start: this.startTime, end: this.endTime };
      }
      this.$emit("save", settings);
    },
  },
};
</script>

<style scoped>
.list-editor-settings {
  position: absolute;
  bottom: 0;
  padding: 10px;
  padding-bottom: 20px;
  width: 100vw;
  /* height: 100vh; */
  background-color: white;
  text-align: left;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.233);
}
.setting {
  padding: 8px;
}
.bg-pink {
  background-color: pink;
}
</style>